/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const caseDetailsStyles = {
  container: {
    textAlign: "left",
    padding: "25px",
  },
  boxHeadingData: {
    textAlign: "center",
    color: "text.primary",
    fontWeight: 400,
  },
  subheader: {
    marginTop: "40px",
  },
  divider: {
    backgroundColor: "#cdcdcd",
    width: "100%",
    height: "1px",
    margin: "10px 0",
  },
  label: (theme: Theme) => ({
    fontWeight: 400,
    paddingTop: "16px",
    [theme.breakpoints.up("md")]: {
      paddingRight: "8px",
    },
  }),
  buttonShowMore: {
    marginTop: "2rem",
  },
};

export default caseDetailsStyles;
